import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import {
  getCompactMultiSelectMaxTagCount,
  getCompactMultiSelectPlaceholder,
} from '../../../utils/compactMultiSelect';

// Shared antd multi-select for the Voice Inbox subheader filters (Status,
// Department). Each caller supplies its own queryKey, options, selected value,
// and placeholder; selecting updates local state and the URL query under that
// key. Extracted so the filters can no longer drift independently (they were
// near-identical copies of this Select markup).
const VoiceMultiSelectFilter = ({
  updateQuery,
  queryKey,
  value,
  setValue,
  options,
  placeholder,
  minWidth,
  className,
  selectionType,
}) => {
  const handleChange = (selected) => {
    const next = selected || [];
    setValue(next);
    updateQuery({ [queryKey]: next });
  };

  return (
    <Select
      className={`${className} compact-multi-select`}
      mode="multiple"
      placeholder={placeholder}
      options={options}
      showSearch
      allowClear
      value={value}
      onChange={handleChange}
      optionFilterProp="label"
      style={{ minWidth }}
      dropdownMatchSelectWidth={false}
      placement="bottomRight"
      maxTagCount={getCompactMultiSelectMaxTagCount(value)}
      maxTagPlaceholder={getCompactMultiSelectPlaceholder(selectionType)}
    />
  );
};

VoiceMultiSelectFilter.defaultProps = {
  updateQuery: () => {},
  value: [],
  setValue: () => {},
  options: [],
  placeholder: '',
  minWidth: '160px',
  className: 'voice-outbound-subheader-select',
  selectionType: 'items',
};

VoiceMultiSelectFilter.propTypes = {
  updateQuery: PropTypes.func,
  queryKey: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  setValue: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  placeholder: PropTypes.string,
  minWidth: PropTypes.string,
  className: PropTypes.string,
  selectionType: PropTypes.string,
};

export default VoiceMultiSelectFilter;
